import React, { useEffect, useState } from "react";
import ReportContact from "../MobContactCard";
import ReportHome from "../reportHomeCard";
import ReportDetailsCard from "../reportDetailsCard";
import { Row, Col, Container, Image } from "react-bootstrap";
import "./styles.scss";
import MobileReportsCard from "../MobileReportsCard";

const RoofingReport = ({ report, mediaQuery }) => {
  const [streetViewImage,setStreetViewImage]=useState('')
  const {
    mapbox_image,
    building_image,
    property_address,
  } = report;


  useEffect(()=>{
    if(mapbox_image){
      const [long,lat]=mapbox_image.split('static')[1].split(',')
      const sVImage=`https://maps.googleapis.com/maps/api/streetview?size=400x400&location=${lat},${long?.substring(1)}&fov=50&heading=5&pitch=5&key=AIzaSyCRJDjS3oiXg8FP8SuTGM4DDvIWfxOKyaY`
      setStreetViewImage(sVImage)
    }

  },[mapbox_image])

  console.log('QQQ',streetViewImage)

  return (
    <>
      <Container className="mb-5">
          <Row>
            <Col>
              <a
                href="https://remoteroofing.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  className="logo"
                  width="130px"
                  src={require("../../assets/images/mainlogo.svg")}
                />
              </a>
            </Col>
            <Col className="mobile-section">
              <a href="tel:(800)401-7716" style={{whiteSpace:'nowrap'}}>
                +1 (800) 401-7716
                {/* (972)-433-7267 */}
                <Image
                  className="icon-res"
                  width="70px"
                  src={require("../../assets/images/call.png")}
                />
              </a>
            </Col>
            <hr className='horizontal-line'></hr>
          </Row>
          <Row>
            <Col md={4}>
              <div className='mb-3'>
              <ReportHome image={mapbox_image} address={property_address} />

                </div>
                {/* <img src={streetviewImage} alt='image'/> */}
                  {mediaQuery !== "isMobile" && (  <div>
                    <div className='mb-3'>
                    {streetViewImage&& <ReportHome image={streetViewImage} address={property_address} streetview={true} />}    

                      </div>
                  <ReportHome image={building_image} address={property_address} />
    
                      </div>)
                }

            </Col>
            <Col md={8}>
              <ReportDetailsCard report={report} mediaQuery={mediaQuery} />
            </Col>
          </Row>
      </Container>
    </>
  );
};

export default RoofingReport;
